import { w2MasterListPath } from '@/common/app/path'
import { useSiteId } from '@/common/app/site'
import { MasterType, W2MasterData } from '@/common/model/master/w2Master'

import BackButton from '@/components/view/atoms/button/BackButton'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'

import MasterForm from '@/components/container/form/modules/master/master/MasterForm'

interface Props {
  masterType: MasterType
  master?: W2MasterData
  onRefetch?: () => void
}

const MasterEditPage = ({ masterType, master, onRefetch }: Props) => {
  const siteId = useSiteId()
  return (
    <>
      <Main type={MainLayoutType.SMALL}>
        <BackButton link={w2MasterListPath(siteId, masterType)} />
        <MasterForm siteId={siteId} masterType={masterType} master={master} onRefetch={onRefetch} />
      </Main>
    </>
  )
}

export default MasterEditPage
